import './AVIRow.scss';

import React, { Component } from 'react';

import PropTypes from 'prop-types';

export class AVIRow extends Component {
  
  static propTypes = {
    children: PropTypes.any,
    style: PropTypes.object
  }

  static defaultProps = {
    style: {}
  }
  render () {
    const { children, style } = this.props;
    return <div className='avi-row' style={style}>{children}</div>;
  }
}
